import { AxiosInstance, default as axios } from 'axios'
import { getStoredPasscode } from '../utils/passcodeUtils'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

let failedQueue: any = []
export const setClientTimeout = (timeout: number | null) => {
  if (timeout) {
    client.defaults.timeout = timeout
  }
}

const processQueue = (error: any) => {
  failedQueue.forEach((prom: any) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve()
    }
  })
  failedQueue = []
}

export const client = createAxiosClient({
  options: {
    baseURL: API_BASE_URL,
    timeout: 30000
  }
})
function createAxiosClient({ options }: any): AxiosInstance {
  const client = axios.create(options)
  client.interceptors.request.use((config) => {
    const token = getStoredPasscode()
    if (token) {
      config.headers['X-API-PASSCODE'] = token
    } else {
      delete config.headers['X-API-PASSCODE']
    }
    return config
  })
  client.interceptors.response.use(
    (response) => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response
    },
    (error) => {
      const originalRequest = error.config
      // If error, process all the requests in the queue and logout the user.
      const handleError = (error: any) => {
        processQueue(error)
        // TODO: logout user?
        return Promise.reject(error)
      }
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error)
    }
  )
  return client
}
